// Single source of truth for the Inglis brand color, kept in sync with the
// `inglis.blue`/`inglis.blue-dark` tokens in tailwind.config.js. Import this instead of
// hardcoding the hex value in inline styles.
export const INGLIS_BLUE = '#004090'
export const INGLIS_BLUE_DARK = '#002f6c'
